import PropTypes from 'prop-types'
import React from 'react'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import i18n from 'simple-react-i18n'
import Checkbox from '../../../components/forms/Checkbox'
import { getI18nTitleData, normalizeString } from '../../../utils/StringUtil'
import CartographyThemeDto from '../../dto/CartographyThemeDto'
import UserAction from '../user/actions/UserAction'
import SelectionTableModal from 'components/modal/SelectionTableModal'
import Input from '../../../components/forms/Input'
import { uniq } from 'lodash'
import { Grid } from '@mui/material'

const headers = ['login', 'admin']

const headersUser = ['login', 'name', 'mail', 'mobile', 'tel', 'admin', 'metadata', 'organism', 'lastConnexion']

const LayerRightsModal = ({
    theme,
    selectedUsers,
    open,
    toggleModal,
}) => {
    const {
        users,
        applicativeUsers,
    } = useSelector(store => ({
        users: store.UserReducer.users,
        applicativeUsers: store.UserReducer.applicativeUsers,
    }), shallowEqual)

    const dispatch = useDispatch()

    const getUsers = () => {
        return uniq([...users, ...applicativeUsers]).map((u) => {
            return {
                ...u,
                admin: u.admin === '1' ? (<Checkbox checked disabled />) : '',
                id: u.login,
            }
        })
    }

    const getSelectedUsers = () => {
        const allUsers = uniq([...users, ...applicativeUsers])
        return selectedUsers.map(({ login }) => {
            const userFind = allUsers.find((u) => u.login === login) || {}
            return userFind.login
        })
    }

    const onValidate = (newSelectedUsers) => {
        dispatch(UserAction.assignThemeToUsers(theme.id, newSelectedUsers)).then(() => {
            toggleModal()
        })
    }

    const listData = getUsers() || []
    const selectedData = getSelectedUsers() || []
    return (
        <SelectionTableModal
            isOpen={open}
            onClose={toggleModal}
            onValidate={onValidate}
            title={theme.name}

            listData={listData}
            listHeaders={headers}
            listTitle={getI18nTitleData(i18n.user, i18n.users, listData)}

            defaultSelectionList={selectedData}
            selectionListHeaders={headers}
            selectionListTitle={getI18nTitleData(i18n.selectedUser, i18n.selectedUsers, selectedData)}

            titleBackgroundColor={theme?.color}
            color={'white'}
            filterField={({
                filter,
                setFilter,
            }) => (
                <Grid size={6} sx={{ padding: '10px 0px' }}>
                    <Input
                        title={i18n.search}
                        value={filter.searchValue}
                        onChange={searchValue => setFilter(prev => ({ ...prev, searchValue }))}
                    />
                </Grid>
            )}
            filterFunction={(list, { searchValue }) => {
                const searchValueFormat = normalizeString(searchValue)
                return searchValue ? list.filter(p => normalizeString(headersUser.map(key => p[key])).includes(searchValueFormat)) : list
            }}
        />
    )
}

LayerRightsModal.propTypes = {
    selectedUsers: PropTypes.arrayOf(PropTypes.string),
    theme: PropTypes.instanceOf(CartographyThemeDto),
    toggleModal: PropTypes.func.isRequired,
    open: PropTypes.bool.isRequired,
    openProgressBar: PropTypes.bool,
}

export default LayerRightsModal
